export function buildCategoryPath(slug: string | number): string {
  const normalizedSlug = String(slug).trim();
  if (normalizedSlug.toLocaleLowerCase() === "all") return "/products";
  return `/categories/${encodeURIComponent(normalizedSlug)}`;
}
